<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row justify-content-between">
          <div>
            <h4>
              <i class="fa fa-solid fa-calendar" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div v-if="caseSummaryList && Array.isArray(caseSummaryList) && caseSummaryList.length > 0">
            <div class="bg-white shadow-sm rounded-5 p-2 cursor-pointer">
              <i :title="csvTitle" class="fa-solid fa-file-csv primary-color pointer" style="font-size: 20px;" @click="spcmCaseSummaryList(false, true)"></i>
            </div>
          </div>
        </div>
        <div class="iq-card row p-3" >
          <b-col>
            <b-row class="col-12">
              <!-- SPCM Category Ex. GIDE ONE, EXCLUSIVE Etc -->
              <b-col class="col-12 col-sm-6">
                <select v-model="whereFilter.spcm_category" class="form-control" @change="handleCategoryChange()">
                  <option :value="null" disabled>Choose Category</option>
                  <option :value=null>All</option>
                  <option v-for="(category, index) of SPCM_CATEGORY_LIST" :key="(index+1)" :value="category?.spcm_category">
                    {{category?.spcm_category}}
                  </option>
                </select>
              </b-col><!-- SPCM Category -->

              <!-- Counselling Status -->
              <b-col class="col-12 col-sm-6">
                <select v-model="whereFilter.spcm_state" class="form-control" @change="handleStateChange()">
                  <option :value="null" disabled>Choose Status</option>
                  <option :value=null>All</option>
                  <option v-for="(state, index) of SPCM_STATE_LIST" :key="(index+1)" :value="index">
                    {{state}}
                  </option>
                </select>
              </b-col><!-- Counselling Status -->
            </b-row>
          </b-col>
        </div>
        <div :style="{ minHeight: (!caseSummaryList || caseSummaryList?.length === 0) ? '400px' : 'auto'}" class="iq-card row p-3 d-flex align-items-center">
          <b-col md="12" v-if="caseSummaryList && Array.isArray(caseSummaryList) && caseSummaryList.length > 0">
            <b-table
              hover
              responsive
              :items="caseSummaryList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc">
              <template v-slot:cell(id)="data">
                {{caseSummaryList.indexOf(data.item)+1}}
              </template>
              <template v-slot:cell(counselor_name)="data">
                <span :title="data.item.counselor_name">{{ data.item.counselor_name }}</span><br>
                <small class="text-nowrap">Id:&nbsp;{{ data?.item?.counselor_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Counselor Id" @click="doCopy( data?.item?.counselor_id)"></i></small><br>
                <small class="text-nowrap">Email:&nbsp;{{ data?.item?.counselor_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Counselor Email" @click="doCopy( data?.item?.counselor_email)"></i></small><br>
                <b-row class="py-2">
                  <b-button title="View Students for Counselor" style="border: none;" class="bg-transparent p-0 pl-3" @click="openApp(data?.item?.counselor_id, 'spcm_analytics_counselor_students')"><i class="font-size-18 fa-solid fa-users primary-color"></i></b-button>
                  <b-button title="View Counselor meetings" style="border: none;" class="bg-transparent p-0 pl-3" @click="openApp(data?.item?.counselor_id, 'spcm_analytics_counselor_meetings')"><i class="font-size-18 fa-solid fa-calendar primary-color"></i></b-button>
                </b-row>
                <!-- <b-button variant="mr-1 mb-1 " @click="openApp(data?.item?.counselor_id, "spcm_analytics_counselor_students")" title="View Students"><i class="fa fa-eye font-size-20" aria-hidden="true" ></i></b-button> -->
              </template>
            </b-table>
            <div class="d-flex align-items-center mt-3 py-3">
              <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
                <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
              </b-col>
            </div>
          </b-col>
          <b-col v-else-if="caseSummaryList && Array.isArray(caseSummaryList) && caseSummaryList.length === 0">
            <h5 class="text-secondary text-center">No case summaries found.</h5>
          </b-col>
          <b-col v-else class="text-center py-5">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <h5 class="mt-3 text-primary">Loading case summaries...</h5>
            <p class="text-muted mb-0">Please wait while we fetch your case summaries.</p>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>
<script>
import { socialvue } from "../../../config/pluginInit.js"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import Utility from "../../../Utils/utility.js"
import Multiselect from "vue-multiselect"

export default {
  name: "SpcmAnalyticsCaseSummary",
  comments: {
    Multiselect
  },
  data () {
    return {
      cvCardTitle: "Counselor Report",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Counselor Report",
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Counselor Info", key: "counselor_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Total Students", key: "total_student_count", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Class Not Mentioned", key: "Class_undefined", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Class 8", key: "Class_08", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Class 9", key: "Class_09", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Class 10", key: "Class_10", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Class 11", key: "Class_11", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Class 12", key: "Class_12", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Case Opened", key: "CASE_OPENED", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Case Closed", key: "CASE_CLOSED", class: "text-left align-text-top w-150px", sortable: true }
      ],
      caseSummaryList: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      doCopy: Utility.doCopy,
      whereFilter: {
        spcm_category: null,
        spcm_state: null
      },
      SPCM_STATE_LIST: {},
      SPCM_CATEGORY_LIST: {},
      totalDataCount: 0,
      csvTitle: "Download case summary Analytics"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    socialvue.index()
    this.spcmCaseSummaryList()
    this.spcmCategory()
    this.spcmStateList()
  },
  methods: {
    /**
     * spcmCategory
     */
    async spcmCategory () {
      try {
        let spcmCategoryListResp = await Spcms.spcmCategoryList(this)
        if (spcmCategoryListResp.resp_status) {
          let categoryObjList = spcmCategoryListResp.resp_data.data
          this.SPCM_CATEGORY_LIST = categoryObjList
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCategoryList() and Exception:", err.message)
      }
    },
    /**
     * spcmStateList
     */
    async spcmStateList () {
      try {
        let spcmStateListResp = await Spcms.spcmStateList(this)
        if (spcmStateListResp.resp_status) {
          let stateObjList = spcmStateListResp.resp_data.data
          for (let stateObj of stateObjList) {
            this.SPCM_STATE_LIST[stateObj.state_id] = stateObj.state
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStateList() and Exception:", err.message)
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.spcmCaseSummaryList(true)
    },
    /**
     * spcmCaseSummaryList
     */
    async spcmCaseSummaryList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.downloadCsv = downloadCsv

        let payloadObj = {
          whereFilter: this.whereFilter
        }
        let spcmCaseSummaryListResp = await Spcms.SpcmAnalyticsCaseSummary(this, payloadObj)
        if (spcmCaseSummaryListResp.resp_status) {
          if (downloadCsv) {
            window.open(spcmCaseSummaryListResp.resp_csv_file_url)
            return
          }

          if (!loadViaLoadMore) {
            this.caseSummaryList = spcmCaseSummaryListResp.resp_data.data
          }
          else {
            this.caseSummaryList = [ ...this.caseSummaryList, ...spcmCaseSummaryListResp.resp_data.data ]
          }
          this.totalDataCount = spcmCaseSummaryListResp.resp_data_total_count
        }
        else {
          this.toastMsg = spcmCaseSummaryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.caseSummaryList = []
        }
      }
      catch (err) {
        this.caseSummaryList = []
        this.toastMsg = "An error occurred while fetching case summary list. Please try again later."
        this.toastVariant = "danger"
        this.showToast = true
        console.error("Exception occurred at spcmCaseSummaryList() and Exception:", err.message)
      }
    },
    /**
     * openApp
     */
    openApp (counselorId, path) {
      if (path && counselorId) {
        this.$router.push(`/${path}/${counselorId}`)
      }
    },
    /**
     * handleCategoryChange
     */
    handleCategoryChange () {
      this.currentBatchNo = 1
      this.spcmCaseSummaryList()
    },
    /**
     * handleStateChange
     */
    handleStateChange () {
      this.currentBatchNo = 1
      this.spcmCaseSummaryList()
    }
  }
}
</script>
